<template>
  <tr class="product">
    <td class="collapse pr-4">
      <div class="p-4 border border-gray-400 rounded">
        <Icon :type="icon" />
      </div>
    </td>
    <td class="pr-4">
      <div class="font-semibold">
        <Link
          v-if="url"
          :href="url"
          :text="name"
          class="font-semibold underline"
        />
        <strong v-else class="font-semibold">
          {{ name }}
        </strong>
      </div>
      <Info
        v-if="info"
        :text="info.text"
        :date="info.date"
      />
    </td>
    <td class="pr-4">
      <Seat
         v-if="info"
        :category="info.category"
        :theme="info.theme"
        :seat="info.seat"
      />
    </td>
    <td class="pr-4">
      <Option
        :id="id"
        :options="options"
        :disabled="!abilities.updateOption"
      />
    </td>
    <td class="pr-4">
      <Amount
        :id="id"
        :amount="amount"
        :disabled="!abilities.updateAmount"
      />
    </td>
    <td class="collapse pr-2">
      <Link
        v-if="abilities.delete"
        :href="route('cart.lines.destroy', [id])"
        preserve-scroll
        method="delete"
        class="w-7 h-7 flex text-gray-700 hover:text-gray-900"
        as="button"
      >
        <Icon type="trash" class="m-auto" />
      </Link>
    </td>
    <td class="collapse text-right whitespace-nowrap">
      <strong class="text-lg">
        {{ formatPrice(total) }}
      </strong>
    </td>
  </tr>
  <template v-for="discount in discounts" :key="discount.id">
    <Coupon :line="id" v-bind="discount" />
  </template>
  <template v-if="abilities.applyCoupon">
    <tr class="coupon">
      <td class="pr-4"></td>
      <td colspan="6">
        <ApplyCoupon
          class="py-1"
          :id="id"
          :theme="info?.theme"
        />
      </td>
    </tr>
  </template>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';
import Info from '../Shared/Info.vue';
import Seat from '../Shared/Seat.vue';
import Amount from '../Shared/Amount.vue';
import Option from '../Shared/Option.vue';
import ApplyCoupon from '../Shared/ApplyCoupon.vue';
import Coupon from './Coupon.vue';
import { computed } from 'vue';
import rescue from '@/helpers/rescue';
import formatPrice from '@/helpers/formatPrice';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    required: false,
  },
  info: {
    type: String,
    required: false,
  },
  amount: {
    type: [Number, String],
    required: true,
  },
  total: {
    type: [Number, String],
    required: true,
  },
  options: {
    type: Array,
    default: () => [],
  },
  abilities: {
    type: Object,
    required: true,
  },
  linkable_type: {
    type: String,
    default: 'default',
  },
  discounts: {
    type: Array,
    default: () => [],
  },
});

const icon = computed(() => ({
  'ticket':  'ticket',
  'voucher': 'voucher',
  'coupon':  'coupon',
  'default': 'check',
}[props.linkable_type]));

const info = computed(() => rescue(() => JSON.parse(props.info), {
  text: info,
}));

</script>

<style scoped>

tr.product td,
tr.coupon td {
  padding-bottom: 1rem;
}

tr.product + tr.product td,
tr.coupon + tr.product td {
  padding-top: 1rem;
  border-top: 1px solid #E4E7F2;
}

tr:last-child {
  border-bottom: 1px solid #E4E7F2;
}

</style>
